import {
  SET_MONITOR_TASK_LIST,
  SET_SUBSCRIBE_CONTROL_LIST,
  SET_MONITOR_TASK_LIST_PAGE_NUM,
  SET_MONITOR_TASK_LIST_PAGE_SIZE,
  SET_MONITOR_TABLE_LOADING,
} from './mutation-types'
import { Message } from 'element-ui'
import api from '@/api'
import { i18n } from '@/i18n'

const monitorTaskListInit = {
  pageCount: 0,
  pageNum: 0,
  total: 0,
  size: 0,
  items: [],
}

const state = {
  /**
   * itemsType = {
   *    id: number
   *    adminId: number
   *    messageType: number
   *    message: string
   *    haveRead:  number  // 0/否，1/是
   *    taskId: number
   *  }
   */
  monitorTaskList: {
    pageCount: 0,
    pageNum: 0,
    total: 0,
    size: 0, // size在这里特指未读消息数量
    items: [],
  },
  monitorPageInfo: {
    pageNum: 0,
    pageSize: 50,
  },
  /**
   * type = {
   *  desc: string // 消息类型描述
   *  messageType: number // 消息类型
   *  tips: string // 消息提示信息
   *  thresholdCount: number // 阈值n个任务/帧
   *  thresholdRate: number //阈值概率n%
   *  enable: number //是否选中站内消息，1/是，0/否
   * }
   */
  subscribeControlList: [],
  loadingMonitorTable: false,
}
const mutations = {
  [SET_MONITOR_TASK_LIST](state, payload) {
    state.monitorTaskList = payload
  },
  [SET_SUBSCRIBE_CONTROL_LIST](state, payload) {
    state.subscribeControlList = payload
  },
  [SET_MONITOR_TASK_LIST_PAGE_NUM](state, payload) {
    state.monitorPageInfo.pageNum = payload
  },
  [SET_MONITOR_TASK_LIST_PAGE_SIZE](state, payload) {
    state.monitorPageInfo.pageSize = payload
  },
  [SET_MONITOR_TABLE_LOADING](state, payload) {
    state.loadingMonitorTable = payload
  },
}
const actions = {
  async getMonitorTaskList({ commit, state }) {
    commit(SET_MONITOR_TABLE_LOADING, true)
    const { pageSize, pageNum } = state.monitorPageInfo
    try {
      const monitorTaskListRes = await api.monitorApi.getMonitorTaskList({
        pageSize,
        pageNum,
      })
      commit(SET_MONITOR_TABLE_LOADING, false)
      if (monitorTaskListRes.result) {
        commit(SET_MONITOR_TASK_LIST, monitorTaskListRes.data)
      } else {
        commit(SET_MONITOR_TASK_LIST, monitorTaskListInit)
      }
    } catch (e) {
      commit(SET_MONITOR_TABLE_LOADING, false)
      commit(SET_MONITOR_TASK_LIST, monitorTaskListInit)
    }
  },
  async getMonitorSubscribeControlList({ commit }) {
    commit(SET_MONITOR_TABLE_LOADING, true)
    try {
      commit(SET_SUBSCRIBE_CONTROL_LIST, [])
      const subscribeControlListRes = await api.monitorApi.getMonitorSubscribeControlList()
      commit(SET_MONITOR_TABLE_LOADING, false)
      if (subscribeControlListRes.result) {
        commit(SET_SUBSCRIBE_CONTROL_LIST, subscribeControlListRes.data)
      }
    } catch (e) {
      commit(SET_MONITOR_TABLE_LOADING, false)
      commit(SET_SUBSCRIBE_CONTROL_LIST, [])
    }
  },
  async handleSubscribe(_, payload) {
    const res = await api.monitorApi.handleSubscribe(payload)
    if (res.result) {
      Message({
        message: i18n.t('common_successful_operation'),
        type: 'success',
      })
    }
  },
  async setMonitorTaskListPageNum({ commit, dispatch }, payload) {
    commit(SET_MONITOR_TASK_LIST_PAGE_NUM, payload)
    dispatch('getMonitorTaskList')
  },
  async setMonitorTaskListPageSize({ commit, dispatch }, payload) {
    commit(SET_MONITOR_TASK_LIST_PAGE_SIZE, payload)
    dispatch('getMonitorTaskList')
  },
  async deleteMessage({ commit, dispatch }, payload) {
    const res = await api.monitorApi.deleteMessage(payload)
    if (res.result) {
      commit(SET_MONITOR_TASK_LIST_PAGE_NUM, 0)
      dispatch('getMonitorTaskList')
    }
  },
  async markMessage({ commit, dispatch }, payload) {
    const res = await api.monitorApi.markMessage(payload)
    if (res.result) {
      commit(SET_MONITOR_TASK_LIST_PAGE_NUM, 0)
      dispatch('getMonitorTaskList')
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
